export const setAgentAIs = (agentAIs) => ({
  type: "SET_AGENT_AIS",
  payload: agentAIs,
});
